import Vue from 'vue'
import Router from 'vue-router'
import About from '@/components/About'
import Games from '@/components/Games'
import Team from '@/components/Team'
import Assets from '@/components/Assets'
import Contact from '@/components/Contact'

Vue.use(Router)
let router = new Router({
  mode: 'history',
 routes: [
   {
     path: '*',
     redirect: '/'
   },
   {
     path: '/',
     name: 'about',
     component: About
   },
   {
     path: '/games',
     name: 'games',
     component: Games
   },
   {
     path: '/team',
     name: 'Team',
     component: Team
   },
   {
     path: '/assets',
     name: 'Assets',
     component: Assets
   },
   {
     path: '/contact',
     name: 'Contact',
     component: Contact
   }
 ],
 // eslint-disable-next-line no-unused-vars
 scrollBehavior (to, from, savedPosition) {
   return { x: 0, y: 0 }
 }
})
export default router
